import React from 'react'
import { component_tool, utils_tool } from '@/tool'
import { Card, Icon } from 'antd'
const { WizComponent, WizButton, WizSelect, WizInput, WizModal } = component_tool
import { Table } from 'antd'
let { excelUtils } = utils_tool

import './index.less'

class Criteria extends WizComponent {

    componentName = 'Criteria'

    constructor(props) {
        super(props)
        this.state = {
            index: 0,
            tabs: [],
            dataArray: [],
            showRequired: false,
            timestamp: new Date().getTime(),
            file: null,
            fileData: null
        }
    }

    propsAndStateOnChange = {
        data: this._dataOnChange.bind(this),
    }

    _dataOnChange(nextProps, nextState) {
        if (nextProps.data) {
            let { tabs, dataArray } = this._convert(nextProps.data)
            nextState.tabs = tabs
            nextState.dataArray = dataArray
            nextState.timestamp = new Date().getTime()
        }
        return true
    }

    _convert = (data) => {
        let tabs = []
        let dataArray = []
        data && data.length && data.forEach(tab => {
            let { id, name, elementList } = tab
            let dataSource = []
            elementList && elementList.length && elementList.forEach(element => {
                let { childList } = element
                let span = 0
                childList && childList.length && childList.forEach(child => {
                    let { standardList } = child
                    standardList && standardList.length && standardList.map((standard, index) => {
                        let { content, evaluation, remark } = standard
                        let row = {
                            id: standard.id,
                            essentialFactor: element.name || '',
                            primaryIndex: child.name || '',
                            evaluationCriteria: content || '',
                            results: evaluation,
                            remarks: remark || '',
                            rowSpans: {
                                essentialFactorSpan: 0,
                                primaryIndexSpan: index === 0 ? standardList.length : 0
                            }
                        }
                        dataSource.push(row)
                        span++
                    })
                })
                if (dataSource.length) {
                    dataSource[dataSource.length - span].rowSpans.essentialFactorSpan = span
                }
            })
            tabs.push({ id, name })
            dataArray.push(dataSource)
        })
        return { tabs, dataArray }
    }

    _onSelect = (v, o, r) => {
        let { realTimeUpdate } = this.props
        let { dataArray, index } = this.state
        let dataSource = dataArray[index]
        dataSource && dataSource.length && dataSource.map(item => {
            if (item.id === r.id) {
                item.results = v
                if (v === 1 || item.remarks) {
                    realTimeUpdate && realTimeUpdate({
                        id: item.id,
                        evaluation: v,
                        remark: item.remarks
                    })
                }
            }
            return item
        })
        this.setState({ dataArray, timestamp: new Date().getTime() })
    }

    _onBlur = (v, r) => {
        let { realTimeUpdate } = this.props
        let { dataArray, index } = this.state
        let dataSource = dataArray[index]
        dataSource && dataSource.length && dataSource.map(item => {
            if (item.id === r.id) {
                item.remarks = v
                if (v || item.results === 1) {
                    realTimeUpdate && realTimeUpdate({
                        id: item.id,
                        evaluation: item.results,
                        remark: v
                    })
                }
            }
            return item
        })
        this.setState({ dataArray, timestamp: new Date().getTime() })
    }

    _onChange = (v, r) => {
        let { dataArray, index } = this.state
        let dataSource = dataArray[index]
        dataSource && dataSource.length && dataSource.map(item => {
            if (item.id === r.id) {
                item.remarks = v
            }
            return item
        })
        this.setState({ dataArray })
    }

    _checkRow = (row) => {
        let flag = false
        if (row) {
            let { results, remarks } = row
            switch (results) {
                case 0:
                    if (remarks && remarks.length <= 20) {
                        flag = true
                    }
                    break
                case 1:
                    if (!remarks || remarks.length <= 20) {
                        flag = true
                    }
                    break
                default:
            }
        }
        return flag
    }

    _onSave = () => {
        let { onSave } = this.props
        let { dataArray } = this.state
        let list = []
        let flag = true
        dataArray && dataArray.length && dataArray.forEach(dataSource => {
            flag && dataSource && dataSource.length && dataSource.forEach(row => {
                if (!flag) return
                let { id, results, remarks } = row
                if (!this._checkRow(row)) {
                    flag = false
                    this.setState({ showRequired: true })
                    wizNotice.warn('请检查评估内容')
                }
                list.push({ id, evaluation: results, remark: remarks })
            })
        })
        flag && onSave && onSave(list)
    }

    _renderTitle = (tabs, dataArray) => {
        let { title, type, onExport } = this.props
        let click = () => {
            let data = tabs.map((tab, index) => {
                let sheetName = tab.name || ''
                sheetName = sheetName.replaceAll('<br/>', '\n')
                sheetName = sheetName.replaceAll(/<[^<>]+>/g, '')
                return { sheetName, rows: dataArray[index] || [] }
            })
            onExport && onExport(data)
        }
        return (
            <div className='card-title-row'>
                <Icon className='icon' type='switcher' />
                <div className='flex-sub'>{title}</div>
                {
                    type === 'look' && tabs && tabs.length
                        ? <WizButton className='export' onClick={() => click()}>{'导出'}</WizButton>
                        : null
                }
            </div>
        )
    }

    _onTab = (tab, i) => {
        this.setState({ index: i })
    }

    _renderTab = (tab, i) => {
        let className = i === this.state.index ? 'criteria-tab-item criteria-tab-active' : 'criteria-tab-item'
        return <div key={'criteria_tab_' + i} className={className} onClick={() => this._onTab(tab, i)} dangerouslySetInnerHTML={{ __html: tab.name || '' }}></div>
    }

    _convertTreeData(fileData) {
        let treeData = []
        if (fileData) {
            let parser = new DOMParser()
            let doc = parser.parseFromString(fileData[0], 'text/xml')
            let array = doc.getElementsByTagName('tr')
            let count = 0
            let titleArr = ['评估模块', '要素', '一级指标', '评估标准', '评估结果', '备注']
            rows: for (let i = 0; i < array.length; i++) {
                let tds = array[i].children
                if (i === 0) {
                    if (tds.length !== titleArr.length) {
                        return false
                    } else {
                        for (let j = tds.length - 1; j >= 0; j--) {
                            let content = tds[j].innerHTML
                            let title = titleArr[j]
                            if (!content || title !== content.trim()) {
                                return false
                            }
                        }
                    }
                    count = tds.length
                } else {
                    if (tds.length < count) {
                        let data
                        let obj = {}
                        let num = 0
                        for (let j = tds.length - 1; j >= 0; j--) {
                            let content = tds[j].innerHTML
                            switch (num) {
                                case 0:
                                    obj.remark = content
                                    break
                                case 1:
                                    obj.evaluation = content
                                    break
                                case 2:
                                    obj.content = content
                                    if (content === '') {
                                        continue rows
                                    }
                                    if (obj.evaluation !== '1' && obj.evaluation !== '0') {
                                        return false
                                    } else if (obj.evaluation === '0' && obj.remark === '') {
                                        return false
                                    } else {
                                        data = obj
                                    }
                                    break
                                case 3:
                                    data = { name: content, standardList: [data] }
                                    break
                                case 4:
                                    data = { name: content, childList: [data] }
                                    break
                                case 5:
                                    data = { name: content, elementList: [data] }
                                    break
                            }
                            num++
                        }
                        let arr = treeData
                        for (let k = 0; k <= count - tds.length - 1; k++) {
                            arr = arr[arr.length - 1].standardList || arr[arr.length - 1].childList || arr[arr.length - 1].elementList
                        }
                        arr.push(data)
                    } else {
                        let data
                        let obj = {}
                        let num = 0
                        for (let j = count - 1; j >= 0; j--) {
                            let content = tds[j].innerHTML
                            switch (num) {
                                case 0:
                                    obj.remark = content
                                    break
                                case 1:
                                    obj.evaluation = content
                                    break
                                case 2:
                                    obj.content = content
                                    if (content === '') {
                                        continue rows
                                    }
                                    if (obj.evaluation !== '1' && obj.evaluation !== '0') {
                                        return false
                                    } else if (obj.evaluation === '0' && obj.remark === '') {
                                        return false
                                    } else {
                                        data = obj
                                    }
                                    break
                                case 3:
                                    data = { name: content, standardList: [data] }
                                    break
                                case 4:
                                    data = { name: content, childList: [data] }
                                    break
                                case 5:
                                    data = { name: content, elementList: [data] }
                                    break
                            }
                            num++
                        }
                        treeData.push(data)
                    }
                }
            }
        }
        return treeData
    }

    _importFile = () => {
        let element = document.getElementById('importCriteria')
        let file = element.files[0]
        this.setState({ file: file }, () => {
            excelUtils.importExcel(
                { target: { files: [file] } },
                (fileData) => {
                    let data = this._convertTreeData(fileData)
                    this.setState({ timestamp: new Date().getTime() }, () => {
                        if (data) {
                            this.props.importExcel && this.props.importExcel(data)
                        } else {
                            wizNotice.error('请检查导入评估结果是否正确')
                        }
                    })
                },
                { dataFun: ['sheet_to_html'] }
            )
        })
    }

    _onUpdateCriteria = () => {
        let { onUpdateCriteria } = this.props
        WizModal.confirm({
            title: '注意',
            content: '即将更新标准，更新后原评估数据将会失效，是否确认更新？',
            onOk: () => {
                onUpdateCriteria && onUpdateCriteria()
            },
            onCancel() {
            }
        })
    }

    render() {
        let { index, tabs, dataArray, timestamp, showRequired } = this.state
        let { type } = this.props
        let dataSource = dataArray[index] || []
        let columns = [{
            title: '要素',
            name: 'essentialFactor',
            dataIndex: 'essentialFactor',
            render: (v, r, i) => {
                const obj = {
                    children: <span dangerouslySetInnerHTML={{ __html: v }}></span>,
                    props: {
                        rowSpan: r.rowSpans.essentialFactorSpan
                    }
                }
                return obj
            }
        }, {
            title: '一级指标',
            name: 'primaryIndex',
            dataIndex: 'primaryIndex',
            render: (v, r, i) => {
                const obj = {
                    children: <span dangerouslySetInnerHTML={{ __html: v }}></span>,
                    props: {
                        rowSpan: r.rowSpans.primaryIndexSpan
                    }
                }
                return obj
            }
        }, {
            title: '评估标准',
            name: 'evaluationCriteria',
            dataIndex: 'evaluationCriteria',
            render: (v) => {
                return <span dangerouslySetInnerHTML={{ __html: v }}></span>
            }
        }, {
            title: '评估结果',
            name: 'results',
            dataIndex: 'results',
            width: 150,
            className: 'criteria-operate',
            render: (v, r, i) => {
                if (type === 'evaluation') {
                    let defaultValue = undefined
                    switch (v) {
                        case 0:
                        case 1:
                            defaultValue = v
                    }
                    let selectProps = {
                        key: 'criteria_select_' + r.id,
                        className: 'criteria-evaluation-select',
                        size: 'small',
                        defaultValue,
                        onChange: (value, option) => this._onSelect(value, option, r)
                    }
                    let options = [
                        <WizSelect.Option key={'criteria_select_' + r.id + '_0'} value={0}>
                            <div className='remote-assessment-score'>{0}</div>
                        </WizSelect.Option>,
                        <WizSelect.Option key={'criteria_select_' + r.id + '_1'} value={1}>
                            <div className='remote-assessment-score'>{1}</div>
                        </WizSelect.Option>
                    ]
                    let content = [
                        <WizSelect {...selectProps} >
                            {options}
                        </WizSelect>
                    ]
                    if (showRequired) {
                        switch (r.results) {
                            case 0:
                            case 1:
                                break
                            default:
                                content.push(<div key={'criteria_select_err_' + r.id} style={{ color: 'red' }}>{'请选择评估结果'}</div>)
                        }
                    }
                    return content
                } else {
                    switch (v) {
                        case 0:
                        case 1:
                            return v
                        default:
                            return ''
                    }
                }
            }
        }, {
            title: '备注',
            name: 'remarks',
            dataIndex: 'remarks',
            width: 300,
            className: 'criteria-operate',
            render: (v, r, i) => {
                if (type === 'evaluation') {
                    let inputProps = {
                        key: 'criteria_input_' + r.id,
                        className: 'criteria-evaluation-input',
                        id: 'criteria_input_' + r.id,
                        defaultValue: v || '',
                        maxLength: 20,
                        onBlur: (e) => {
                            let { value } = e.target
                            this._onBlur(value, r)
                        },
                        onChange: (e) => {
                            let { value } = e.target
                            this._onChange(value, r)
                        }
                    }
                    let content = [<WizInput {...inputProps} />]
                    if (showRequired) {
                        if (r.results === 0 && !r.remarks) {
                            content.push(<div key={'criteria_input_err_' + r.id} style={{ color: 'red' }}>{'请输入备注'}</div>)
                        }
                        if (r.remarks && r.remarks.length > 20) {
                            content.push(<div key={'criteria_input_err_' + r.id} style={{ color: 'red' }}>{'限20字'}</div>)
                        }
                    }
                    return content
                } else {
                    return v || ''
                }
            }
        }]
        let tableProps = {
            key: 'table_' + timestamp,
            columns,
            dataSource,
            pagination: false,
            bordered: true,
            rowKey: 'id'
        }
        return (
            <Card className='antui-card' title={this._renderTitle(tabs, dataArray)}>
                <div className='pre-audit-criteria-row'>
                    <div className='criteria-tabs'>
                        {tabs.map((tab, i) => this._renderTab(tab, i))}
                    </div>
                    {
                        type === 'evaluation' ? [
                            <WizInput key={'importFile_' + timestamp} type='file' accept='.xlsx' id='importCriteria' onChange={() => this._importFile()} />,
                            <WizButton key='importBtn' className='import-btn' onClick={() => document.getElementById('importCriteria').click()}>{'导入评估结果'}</WizButton>,
                            <WizButton key='updateCriteria' className='criteria-btn' onClick={() => this._onUpdateCriteria()}>{'更新标准'}</WizButton>,
                            <WizButton key='save' type='primary' className='criteria-btn' onClick={() => this._onSave()}>{'保存'}</WizButton>
                        ] : null
                    }
                </div>
                <Table {...tableProps} />
            </Card>
        )
    }
}

export default Criteria


